import { ThunkAction } from "redux-thunk";
import { ThunkDispatch } from "redux-thunk/src/types";
import getBackendURL from "../api/api";
import { getCurrentUser, setCurrentUser, User } from "../auth";
import {
	ClowderFile,
	ClowderFolder,
	ClowderFolderPath,
} from "../components/Drawer/AttachmentList/types";
import { preview, request } from "../request";
import { router } from "../router";
import { DataAction } from "../types/action";
import {
	ESRState,
	Facet,
} from "../types/data";
import {
	ADD_USER_TO_GROUPS,
	isValidId,
	LIST_ALL_USERS,
	REMOVE_USER_FROM_GROUP,
} from "./util";

export const UPDATE_USER_QUERY = "UPDATE_USER_QUERY";
export const RESET_USER_QUERY = "RESET_USER_QUERY";
export const UPDATE_ESR_QUERY = "UPDATE_ESR_QUERY";
export const UPDATE_ESR_LIST = "UPDATE_ESR_LIST";
export const UPDATE_ERROR_LIST = "UPDATE_ERROR_LIST";
export const UPDATE_TICKET_COMMENTS = "UPDATE_TICKET_COMMENTS";
export const RESET_ESR_QUERY = "RESET_ESR_QUERY";
export const RESET_NOTIFICATIONS_QUERY = "RESET_NOTIFICATIONS_QUERY";
export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";
export const UPDATE_ESR_SPONSOR_TYPE = "UPDATE_ESR_SPONSOR_TYPE";
export const UPDATE_QUESTION_RESPONSES = "UPDATE_QUESTION_RESPONSES";
export const UPDATE_ADDENDUM_RESPONSES = "UPDATE_ADDENDUM_RESPONSES";
export const UPDATE_DISPLAYED_RESPONSES = "UPDATE_DISPLAYED_RESPONSES";
export const UPDATE_ESR_SUMMARY = "UPDATE_ESR_SUMMARY";
export const UPDATE_REVIEW_SUMMARY = "UPDATE_REVIEW_SUMMARY";
export const UPDATE_REQUEST_FOR_INFO_REVIEW_SUMMARY = "UPDATE_REQUEST_FOR_INFO_REVIEW_SUMMARY";
export const UPDATE_USER_APPROVAL = "UPDATE_USER_APPROVAL";
export const UPDATE_SYSTEM_NOTIFICATIONS = "UPDATE_SYSTEM_NOTIFICATIONS"
export const UPDATE_USER_ADMIN = "UPDATE_USER_ADMIN";
export const MERGE_USERS_SHARING = "MERGE_USERS_SHARING";
export const UPDATE_ESR_PERMISSIONS_LIST = "UPDATE_ESR_PERMISSIONS_LIST";
export const UPDATE_EMAIL_NOTIFICATION_FREQUENCY: "UPDATE_EMAIL_NOTIFICATION_FREQUENCY" =
	"UPDATE_EMAIL_NOTIFICATION_FREQUENCY";
export const IS_USER_PERMITTED_TO_VIEW_ESR = "IS_USER_PERMITTED_TO_VIEW_ESR";
export const RESET_IS_USER_PERMITTED_TO_VIEW_ESR =
	"RESET_IS_USER_PERMITTED_TO_VIEW_ESR";
export const UPDATE_NOTIFICATIONS_QUERY = "UPDATE_NOTIFICATIONS_QUERY";
export const UPDATE_BULK_RESPONSE_IN_PROGRESS = "UPDATE_BULK_RESPONSE_IN_PROGRESS";
export const UPDATE_BULK_RESPONSE_COMPLETE = "UPDATE_BULK_RESPONSE_COMPLETE";
export const RESET_ESR_DETAILS = "RESET_ESR_DETAILS";
export const EXTERNAL_FETCH_IN_PROGRESS = "EXTERNAL_FETCH_IN_PROGRESS";
export const EXTERNAL_FETCH_COMPLETE = "EXTERNAL_FETCH_COMPLETE";
export const UPDATE_NOTIFICATION_STATUS = "UPDATE_NOTIFICATION_STATUS";
export const RESET_ESR_DETAILS_IN_PROGRESS = "RESET_ESR_DETAILS_IN_PROGRESS";
export const RESET_ESR_DETAILS_COMPLETE = "RESET_ESR_DETAILS_COMPLETE";
export const SEND_MESSAGE_IN_PROGRESS = "SEND_MESSAGE_IN_PROGRESS";
export const SEND_MESSAGE_PROGRESS_COMPLETE = "SEND_MESSAGE_PROGRESS_COMPLETE";
export const SEND_MESSAGE_COMPLETE = "SEND_MESSAGE_COMPLETE";
export const UPDATE_ESR_LAST_QUESTION_ID = "UPDATE_ESR_LAST_QUESTION_ID"

export type ESRThunkDispatch = ThunkDispatch<ESRState, unknown, DataAction>;
export type ESRThunkAction<T=unknown> = ThunkAction<
	T,
	ESRState,
	unknown,
	DataAction
>;

export function updateUser(
	payload: {
		email?: string;
		first_name?: string;
		last_name?: string;
		password?: string;
	},
	_callback: () => void,
) {
	return (dispatch: ESRThunkDispatch) => {
		const user = getCurrentUser();
		if (!user) return;
		const url = getBackendURL("/clowder/update_user");
		request.post(url, payload).then(() => {
			const updatedUser: User = {
				...user,
				email: payload.email ?? user.email,
				first_name: payload.first_name ?? user.first_name,
				last_name: payload.last_name ?? user.last_name,
			};
			setCurrentUser(updatedUser);
			dispatch({ type: "SET_USER", user: updatedUser });
			_callback();
		});
	};
}

export function createESR(submitter_id: string): ESRThunkAction {
	// A new ESR is being created.
	return (dispatch) => {
		dispatch({
			type: "SET_QUESTION_LOADING_STATE",
			question_id: "__NEW_ESR__",
			loading: true,
		});
		const url = getBackendURL("/esr/submitreq/");
		request
			.post<{ id: number }>(url, { submitter_id })
			.then(({ data: { id: esrId } }) => {
				dispatch(listESRs(submitter_id));
				dispatch({
					type: "SET_QUESTION_LOADING_STATE",
					question_id: "__NEW_ESR__",
					loading: false,
				});
				const activeLabel = 'initial';
				const activeId = esrId;
				router.navigate(`/esr/${esrId}/${activeLabel}/${activeId}/0`);
			});
	};
}

export function deleteESR(esr_id: string): ESRThunkAction{
	return async (dispatch) => {
		let data = {
			esr_id
		}
		let url = getBackendURL(`/esr/deletereq/`);
		return request.post(url, data);
	}
}

export function createTicket(ticketType: string, data: any): ESRThunkAction{
	return (dispatch) => {
		let url = getBackendURL(`/esr/create_ticket/`);
		// if(ticketType == "LOGIN") url = getBackendURL(`/esr/create_login_ticket/`);
		request.post(url, data)
	}
}


export function viewAllErrorTickets(status: string | undefined = undefined): ESRThunkAction{
	return (dispatch) =>{
		const url = getBackendURL('/esr/tickets/');
		request.get(url, {params: status ? { status } : undefined,})
		.then((res)=>{
			console.log(res)
			dispatch({
				type: UPDATE_ERROR_LIST,
				data: res.data,
			})
		})
		.catch((err) => {
			console.error(err);
		});
	}
}

export function assignTicket(
    ticketId: number
): ESRThunkAction {
    return (dispatch) => {
        const url = getBackendURL(
            "/esr/assign_ticket/"
        );
        request
            .post(url, {
                ticket_id: ticketId,
            })
            .then(() => {
                dispatch(viewAllErrorTickets());
            });
    };
}

export function assignTicketToDevelopers(
    ticketId: number
): ESRThunkAction {
    return (dispatch) => {
        const url = getBackendURL(
            "/esr/assign_to_dev/"
        );
        request
            .post(url, {
                ticket_id: ticketId,
            })
            .then(() => {
                dispatch(viewAllErrorTickets());
            });
    };
}

export function addTicketComment(
    ticketId: number,
    comment: string
): ESRThunkAction {
    return (dispatch) => {
        const url = getBackendURL(
            "/esr/add_ticket_comment/"
        );
        request
            .post(url, {
                ticket_id: ticketId,
                comment,
            })
            .then(() => {
                // dispatch(viewAllErrorTickets());
				dispatch(getTicketComments(ticketId));
            });
    };
}

export function getTicketComments(
    ticketId: number
): ESRThunkAction {
    return (dispatch) => {
        const url = getBackendURL(
            `/esr/tickets/${ticketId}/comments/`
        );

        request.get(url).then((response) => {
            dispatch({
                type: UPDATE_TICKET_COMMENTS,
                ticketId,
                comments: response.data,
            });
        });
    };
}

export function updateTicketStatus(
    ticketId: number,
    ticketStatus: string,
): ESRThunkAction {
    return (dispatch) => {
        const url = getBackendURL(
            "/esr/update_ticket_status/"
        );

        request
            .post(url, {
                ticket_id: ticketId,
                ticket_status: ticketStatus,
            })
            .then(() => {
                dispatch(viewAllErrorTickets());
            });
    };
}

export function createAddendum(
	submitterId: string,
	esrId: string,
): ESRThunkAction {
	// A new ESR is being created.
	return (dispatch) => {
		dispatch({
			type: "SET_QUESTION_LOADING_STATE",
			question_id: "__NEW_ESR__",
			loading: true,
		});
		const url = getBackendURL(`/esr/addendum/${esrId}/`);
		request.post<{ id: number, label: string }>(url, { esrId }).then(({ data: { id: activeId, label: activeLabel } }) => {
			dispatch(listESRs(submitterId));
			dispatch({
				type: "SET_QUESTION_LOADING_STATE",
				question_id: "__NEW_ESR__",
				loading: false,
			});
			router.navigate(`/esr/${esrId}/${activeLabel}/${activeId}/0`);
		});
	};
}

export function listESRs(submitter_id: string, test_only: boolean = false): ESRThunkAction {
	return (dispatch, getState) => {
		const searchParams = new URLSearchParams();
		const query = getState().esr_query;
		for (let [key, value] of Object.entries(query)) {
			if (value == null || (Array.isArray(value) && value.length === 0))
				continue;
			if (Array.isArray(value)) {
				for (const v of value) searchParams.append(key, v);
			} else {
				searchParams.set(key, value);
			}
		}
		const url = getBackendURL(
				"/esr/listrequests/" + submitter_id + "/?test_only=" + test_only + "&" + searchParams.toString(),
			);

		request
			.get<{
				current_page: any[];
				total: number;
				facets: Facet[];
			}>(url)
			.then(({ data: { current_page, total, facets } }) => {
				dispatch({
					type: UPDATE_ESR_LIST,
					current_page,
					total,
					facets,
				});
			});
	};
}

export function updateNotificationStatus(
	notif_id: number,
	status: 0 | 1 | 2,
): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL(`/esr/notifications/${notif_id}`);
		request
			.post(url, {
				status,
			})
			.then(() => dispatch({
				type: UPDATE_NOTIFICATION_STATUS,
				notif_id,
				status,
			}));
	};
}

export function listNotifications(test_only = false): ESRThunkAction {
	return (dispatch, getState) => {
		const searchParams = new URLSearchParams();
		const query = getState().notificationlist_query;
		for (let [key, value] of Object.entries(query)) {
			if (key === 'status') continue; // status is filtered on frontend
			if (value == null  || value === '' || (Array.isArray(value) && value.length === 0))
				continue;
			if (Array.isArray(value)) {
				for (const v of value) searchParams.append(key, v);
			} else {
				searchParams.set(key, value);
			}
		}
		const url = getBackendURL(
			"/esr/notifications/" + "?test_only=" + test_only + "&" + searchParams.toString(),
		);
		request.get(url).then(({ data: { notifications, facets } }) => {
			return dispatch<DataAction>({
				type: UPDATE_NOTIFICATIONS,
				notifications: notifications,
				facets: facets,
			});
		});
	};
}

export function listSysNotifications(): ESRThunkAction {
	return (dispatch, getState) => {
		const url = getBackendURL(
			"/esr/sys_notifications/",
		);
		request.get(url).then(({ data: { sys_notifications} }) => {
			return dispatch<DataAction>({
				type: UPDATE_SYSTEM_NOTIFICATIONS,
				sys_notifications: sys_notifications,
			});
		});
	};
}

export function deleteSystemNotifications(notification_id: string | number): ESRThunkAction {
	return (dispatch, getState) => {
		const url = getBackendURL(
			"/esr/remove_sys_notifications/?notification_id="+notification_id,
		);
		request.delete(url).then(({ data: { sys_notifications} }) => {
			return dispatch<DataAction>({
				type: UPDATE_SYSTEM_NOTIFICATIONS,
				sys_notifications: sys_notifications,
			});
		});
	};
}

export function getESRReviewSummary(esr_id: string): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/esr/review_summary/" + esr_id + "/");
		return request(url).then(({ data }) => {
			return dispatch({
				type: UPDATE_REVIEW_SUMMARY,
				summary: data,
			});
		});
	};
}

export function getESRequstInfoReviewSummary(esr_id: string): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/esr/request_info/" + esr_id + "/");
		return request(url).then(({ data }) => {
			return dispatch({
				type: UPDATE_REQUEST_FOR_INFO_REVIEW_SUMMARY,
				summary: data,
			});
		});
	};
}

export function uploadShapefileESR(
	esrId: string,
	activeLabel: string,
	activeId: string,
	question_id: string,
	file: File,
	user_email: string,
): ESRThunkAction {
	const formData = new FormData();
	formData.append("file", file);
	formData.append("esr_id", activeId);
	formData.append("question_id", question_id);
	formData.append("responder_id", user_email);
	if (
		activeId != null &&
		activeId != esrId &&
		activeLabel != null &&
		activeLabel.length
	)
		formData.append("addendum_label", activeLabel);
	return (dispatch) => {
		dispatch({
			type: "SET_QUESTION_LOADING_STATE",
			question_id,
			loading: true,
		});
		request
			.post(getBackendURL("/esr/uploadshapefile/"), formData)
			.then(() => {
				dispatch({ type: "BUMP_SHAPE_VERSION" });
				dispatch(fetchESRResponses(activeId));
			})
			.catch(console.log)
			.finally(() => {
				dispatch({
					type: "SET_QUESTION_LOADING_STATE",
					question_id,
					loading: false,
				});
			});
	};
}

export function applyFileDiff(
	esrId: string,
	activeLabel: string,
	activeId: string,
	question_id: string,
	enterFiles: File[],
	exitFileIds: string[],
	pending: boolean,
	user_email: string,
): ESRThunkAction {
	return (dispatch) => {
		dispatch({ type: "SET_QUESTION_LOADING_STATE", question_id, loading: true });
		const formData = new FormData();
		formData.append("esr_id", esrId);
		formData.append("question_id", question_id);
		formData.append("responder_id", user_email);
		if (pending) formData.append("pending", "true");
		if (activeId != null && activeId != esrId && activeLabel != null && activeLabel.length)
			formData.append("addendum_label", activeLabel);
		for (const file of enterFiles)
			formData.append("enter_files", file);
		for (const id of exitFileIds)
			formData.append("exit_file_ids", id);
		request
			.post(getBackendURL("/esr/apply_file_diff/"), formData)
			.then(() => {
				dispatch(fetchESRResponses(activeId));
				if (!pending) dispatch(fetchESRSummary(activeId));
			})
			.catch(console.log)
			.finally(() => {
				dispatch({ type: "SET_QUESTION_LOADING_STATE", question_id, loading: false });
			});
	};
}

export function loadCurrentFolder(esr_id: string, folder_id: string) {
	return (dispatch: ESRThunkDispatch) => {
		dispatch({
			type: "UPDATE_CURRENT_FOLDER",
			update: {
				loading: true,
				folder_id,
			},
		});
		request
			.get<{
				folder_id: string;
				path: ClowderFolderPath;
				content: Array<ClowderFolder | ClowderFile>;
				read_only: boolean
			}>(
				getBackendURL(
					`/esr/folder_info/?esr_id=${esr_id}&folder_id=${folder_id}`,
				),
			)
			.then(({ data: { folder_id, path, content, read_only } }) => {
				dispatch({
					type: "UPDATE_CURRENT_FOLDER",
					update: {
						loading: false,
						folder_id,
						path,
						content,
						read_only
					},
				});
			}, console.error);
	};
}

export function loadFileInfo(esr_id: string, file_id: string) {
	return (dispatch: ESRThunkDispatch) => {
		request
			.get(getBackendURL(`/esr/file_info/?esr_id=${esr_id}&file_id=${file_id}`))
			.then(({ data: { name } }) => {
				dispatch({
					type: "UPDATE_FILENAME",
					file_id: file_id,
					filename: name,
				});
			});
	};
}

export function addSubfolder(
	esr_id: string,
	current_folder: string,
	name: string,
) {
	return (dispatch: ESRThunkDispatch) => {
		dispatch({
			type: "UPDATE_CURRENT_FOLDER",
			update: {
				loading: true,
			},
		});
		request
			.post(getBackendURL("/esr/add_folder/"), {
				esr_id,
				name,
				parent_folder: current_folder,
			})
			.then(() => {
				dispatch(loadCurrentFolder(esr_id, current_folder));
			}, console.error);
	};
}

export function deleteSubfolder(
	esr_id: string,
	current_folder: string,
	folder_id: string,
) {
	return (dispatch: ESRThunkDispatch, getState: () => ESRState) => {
		dispatch({
			type: "UPDATE_CURRENT_FOLDER",
			update: {
				loading: true,
			},
		});
		request
			.post(getBackendURL(`/esr/delete_folder/`), {
				esr_id,
				folder_id,
			})
			.then(() => {
				dispatch({
					type: "UPDATE_CLIPBOARD",
					update: getState().clipboard.filter(
						(item) => !(item.type === "folder" && item.id === folder_id),
					),
				});
				dispatch(loadCurrentFolder(esr_id, current_folder));
			}, console.error);
	};
}

export function uploadFileToFolder(
	esr_id: string,
	current_folder: string,
	file: File,
	responder_id: string,
	addendum_label: string,
) {
	return (dispatch: ESRThunkDispatch) => {
		dispatch({
			type: "UPDATE_CURRENT_FOLDER",
			update: {
				loading: true,
				folder_id: current_folder,
			},
		});
		request
			.postForm(getBackendURL("/esr/uploadfile/"), {
				esr_id,
				folder_id: current_folder,
				responder_id,
				addendum_label,
				file,
			})
			.then(() => {
				dispatch(loadCurrentFolder(esr_id, current_folder));
			}, console.error);
	};
}

export function deleteFileFromFolder(
	esr_id: string,
	current_folder: string,
	file_id: string,
) {
	return (dispatch: ESRThunkDispatch, getState: () => ESRState) => {
		dispatch({
			type: "UPDATE_CURRENT_FOLDER",
			update: {
				loading: true,
				folder_id: current_folder,
			},
		});
		request
			.post(getBackendURL(`/esr/delete_file/`), {
				esr_id,
				file_id,
			})
			.then(() => {
				dispatch({
					type: "UPDATE_CLIPBOARD",
					update: getState().clipboard.filter(
						(item) => !(item.type === "file" && item.id === file_id),
					),
				});
				dispatch(loadCurrentFolder(esr_id, current_folder));
				dispatch(fetchESRResponses(esr_id));
			}, console.error);
	};
}

export function copyFile(
	esr_id: string,
	file_id: string,
	to_folder_id: string,
) {
	return async (dispatch: ESRThunkDispatch) => {
		try {
			dispatch({
				type: "UPDATE_CURRENT_FOLDER",
				update: {
					loading: true,
					folder_id: to_folder_id,
				},
			});
			await request.post(getBackendURL("/esr/copy_file/"), {
				esr_id,
				file_id,
				to_folder_id,
			});
			dispatch({
				type: "UPDATE_CLIPBOARD",
				update: [],
			});
		} catch (e) {
			console.error(e);
		} finally {
			dispatch(loadCurrentFolder(esr_id, to_folder_id));
		}
	};
}

export function copyFolder(
	esr_id: string,
	folder_id: string,
	to_folder_id: string,
) {
	return async (dispatch: ESRThunkDispatch) => {
		try {
			dispatch({
				type: "UPDATE_CURRENT_FOLDER",
				update: {
					loading: true,
					folder_id: to_folder_id,
				},
			});
			await request.post(getBackendURL("/esr/copy_folder/"), {
				esr_id,
				folder_id,
				to_folder_id,
			});
		} catch (e) {
			console.error(e);
		} finally {
			dispatch({
				type: "UPDATE_CLIPBOARD",
				update: [],
			});
			dispatch(loadCurrentFolder(esr_id, to_folder_id));
		}
	};
}

export function renameFolder(
	esr_id: string,
	folder_id: string,
	new_name: string,
): ESRThunkAction {
	return async (dispatch: ESRThunkDispatch, getState) => {
		try {
			dispatch({
				type: "UPDATE_CURRENT_FOLDER",
				update: {
					loading: true,
				},
			});
			await request.post(getBackendURL("/esr/rename_folder/"), {
				esr_id,
				folder_id,
				new_name,
			});
		} catch (e) {
			console.error(e);
		} finally {
			const cur_folder_id = getState().current_folder.folder_id;
			dispatch(loadCurrentFolder(esr_id, cur_folder_id));
		}
	};
}

// export function fetchESRSummary(esr_id: string): ESRThunkAction<any> {
// 	// A new ESR has been selected, so load responses and update state.
// 	return (dispatch) => {
// 		const url = getBackendURL("/esr/summary/" + esr_id + "/");
// 		return request(url).then(({ data }) => {
// 			const main = data["esr"];
// 			const active = data["addendums"][data["active"] || 'initial'];
// 			dispatch({
// 				type: UPDATE_ESR_SUMMARY,
// 				main_esr_id: main["id"],
// 				esr_submitted: active["submitted"],
// 				esr_timestamp: active["created"],
// 				esr_sponsor_type: active["sponsor_type"],
// 				cultural_review: active["cultural_review"],
// 				natural_review: active["natural_review"],
// 				regulated_review: active["regulated_review"],
// 				addendums: data["addendums"],
// 				description: active["description"],
// 			});
// 			return data;
// 		});
// 	};
// }

export function fetchESRSummary(esr_id: string): ESRThunkAction<any> {
	// A new ESR has been selected, so load responses and update state.
	return (dispatch) => {
		const url = getBackendURL("/esr/summary/" + esr_id + "/");
		return request(url).then(({ data }) => {
			const main_id = data["main_esr_id"];
			const esr_info = data["info"]
			dispatch({
				type: UPDATE_ESR_SUMMARY,
				main_esr_id: main_id,
				esr_submitted: esr_info["submitted"],
				esr_timestamp: esr_info["created"],
				esr_sponsor_type: esr_info["sponsor_type"],
				cultural_review: esr_info["cultural_review"],
				natural_review: esr_info["natural_review"],
				regulated_review: esr_info["regulated_review"],
				addendums: data["addendums"],
				description: esr_info["description"],
			});
			return data;
		});
	};
}

export function fetchESRPermissions(esr_id: string): ESRThunkAction {
	// A new ESR has been selected, so load responses and update state.
	return (dispatch) => {
		const url = getBackendURL("/esr/fetch_esr_permissions/" + esr_id + "/");
		return request(url)
			.then(({ data }) => {
				return dispatch({
					type: UPDATE_ESR_PERMISSIONS_LIST,
					permissions: data,
				});
			})
			.then(() => {
				dispatch({
					type: IS_USER_PERMITTED_TO_VIEW_ESR,
					is_user_permitted: true,
				});
			})
			.catch((error) => {
				if (
					error.response &&
					error.response.data.startsWith("You are not permitted to view ESR")
				) {
					return dispatch({
						type: IS_USER_PERMITTED_TO_VIEW_ESR,
						is_user_permitted: false,
					});
				}
			});
	};
}

export function fetchESRResponses(esr_id: string): ESRThunkAction<any> {
	// A new ESR has been selected, so load responses and update state.
	return (dispatch) => {
		// fetching responses when you are just updating the answers
		const url = getBackendURL("/esr/questioninfo/" + esr_id + "/");
		return request(url).then(({ data }) => {
			const target_label = data.target;
			const target_responses = data.responses[target_label];
			dispatch({
				type: UPDATE_QUESTION_RESPONSES,
				esr_id: esr_id,
				questions: target_responses.questions,
				responses: target_responses.responses,
				committed_responses: target_responses.committed_responses ?? {},
				concurrent_edits: target_responses.concurrent_edits ?? {},
				responder_ids: target_responses.responder_ids,
				all_responses: data.responses,
				esr_submitted: target_responses.is_esr_submitted,
				is_user_sponsor_in_esr: data?.["is_user_sponsor"] ?? false,
			});
			return data;
		});
	};
}

export function updateESRSponsorType(sponsor_type: string): ESRThunkAction {
	// Put the ESR type into the state for convenience
	return (dispatch) => {
		return dispatch({
			type: UPDATE_ESR_SPONSOR_TYPE,
			esr_sponsor_type: sponsor_type,
		});
	};
}

export function updateQuestionResponse(
	main_esr_id: string,
	active_esr_id: string,
	question_id: string,
	response: string,
	field_type?: string,
	mode: string = "single",
	pending: boolean = false,
) {
	// A single new question has been updated for an ESR.
	if (response.length > 0) {
		// considering cases where questions are fetching from external sources
		// (skip external fetch path for pending writes — only triggers on committed saves)
		if (
			!pending && (
				question_id === "E10" ||
				question_id === "E11" ||
				question_id === "E14"
			)
		) {
			return (dispatch: ESRThunkDispatch) => {
				const url = getBackendURL("/esr/questionresponse/");
				dispatch<DataAction>({
					type: EXTERNAL_FETCH_IN_PROGRESS,
				});
				return request
					.post(url, {
						esr_id: active_esr_id,
						question_id: question_id,
						response: response,
						mode,
					})
					.then(
						() => {
							dispatch(fetchESRResponses(active_esr_id));
							// dispatch(fetchESRSummary(active_esr_id));
							dispatch<DataAction>({
								type: EXTERNAL_FETCH_COMPLETE,
							});
						},
						() => {
							dispatch<DataAction>({
								type: EXTERNAL_FETCH_COMPLETE,
							});
							console.error;
						},
					);
			};
		}
		return (dispatch: ESRThunkDispatch) => {
			const url = getBackendURL("/esr/questionresponse/");
			return request
				.post(url, {
					esr_id: active_esr_id,
					question_id: question_id,
					response: response,
					mode,
					pending,
				})
				.then(() => {
					dispatch(fetchESRResponses(active_esr_id));
					if (!pending) {
						// dispatch(fetchESRSummary(active_esr_id));
						if(question_id === "E92A" || question_id === "E92C" || question_id == "E92CA") {
							dispatch({ type: "BUMP_SHAPE_VERSION" });
						}
					}
				}, console.error);
		};
	} else {
		if (pending) {
			// Pencil mode: stage the clear as a pending empty response.
			// The actual delete happens at commit time on the backend.
			return (dispatch: ESRThunkDispatch) => {
				const url = getBackendURL("/esr/questionresponse/");
				return request
					.post(url, {
						esr_id: active_esr_id,
						question_id: question_id,
						response: "",
						pending: true,
					})
					.then(() => {
						dispatch(fetchESRResponses(active_esr_id));
					}, console.error);
			};
		}
		return (dispatch: ESRThunkDispatch) => {
			const url = getBackendURL("/esr/deleteresponse/");
			return request
				.post(url, {
					esr_id: active_esr_id,
					question_id: question_id,
					field_type,
				})
				.then(() => {
					dispatch(fetchESRResponses(active_esr_id));
					// dispatch(fetchESRSummary(active_esr_id));
				}, console.error);
		};
	}
}

export function fetchConcurrentEdits(esr_id: string) {
	return (dispatch: ESRThunkDispatch) => {
		return request
			.get(getBackendURL(`/esr/concurrentedits/${esr_id}/`))
			.then(({ data }) => {
				dispatch<DataAction>({
					type: "SET_CONCURRENT_EDITS",
					concurrent_edits: data.concurrent_edits,
				});
				return data.concurrent_edits;
			});
	};
}

export function commitESRResponses(esr_id: string) {
	return (dispatch: ESRThunkDispatch) => {
		const doCommit = () => {
			const url = getBackendURL(`/esr/commitresponses/${esr_id}/`);
			dispatch<DataAction>({ type: UPDATE_BULK_RESPONSE_IN_PROGRESS });
			return request
				.post(url)
				.then(() => {
					dispatch(fetchESRResponses(esr_id));
					// dispatch(fetchESRSummary(esr_id));
				}, console.error)
				.finally(() => {
					dispatch<DataAction>({ type: UPDATE_BULK_RESPONSE_COMPLETE });
				});
		};
		return doCommit();
	};
}

export function discardESRResponses(esr_id: string) {
	return (dispatch: ESRThunkDispatch) => {
		const url = getBackendURL(`/esr/discardresponses/${esr_id}/`);
		return request
			.post(url)
			.then(() => {
				dispatch(fetchESRResponses(esr_id));
			}, console.error);
	};
}

export function deleteAttachedFile(
    esr_id: string,
    file_id: string,
    responder_id: string,
) {
    return async (dispatch: ESRThunkDispatch) => {
    try {
      const response = await request.delete(getBackendURL("/esr/attachment/"), {
          params: {
            esr_id,
            file_id,
            responder_id,
          },
        });
    } catch (err) {
      console.error(err);
    }
  };
}

export function deleteRow(esr_id: string, question_id: string, row_id: number) {
	return (dispatch: ESRThunkDispatch) => {
		const url = getBackendURL("/esr/deleterow/");
		return request
			.post(url, {
				esr_id,
				question_id,
				row_id,
			})
			.then(() => {
				dispatch(fetchESRResponses(esr_id));
				// dispatch(fetchESRSummary(esr_id));
			});
	};
}

export function createShape(
	active_esr_id: string,
	question_id: string,
	wkt: string,
): ESRThunkAction {
	return (dispatch) => {
		if (!isValidId(active_esr_id)) return;
		const url = getBackendURL(`/esr/geodata/${active_esr_id}/${question_id}/`);
		request.post(url, { wkt }).then(() => {
			dispatch({ type: "BUMP_SHAPE_VERSION" });
			dispatch(fetchESRResponses(active_esr_id));
			// dispatch(fetchESRSummary(active_esr_id));
		});
	};
}

export function updateShape(
	active_esr_id: string,
	question_id: string,
	identifier: string,
	wkt: string,
): ESRThunkAction {
	return (dispatch) => {
		if (!isValidId(active_esr_id)) return;
		const url = getBackendURL(
			`/esr/geodata/${active_esr_id}/${question_id}/${identifier}/`,
		);
		request.put(url, { wkt }).then(() => {
			dispatch({ type: "BUMP_SHAPE_VERSION" });
			dispatch(fetchESRResponses(active_esr_id));
			// dispatch(fetchESRSummary(active_esr_id));
		});
	};
}

export function deleteShape(
	active_esr_id: string,
	question_id: string,
	identifier: string,
): ESRThunkAction {
	return (dispatch) => {
		if (!isValidId(active_esr_id)) return;
		const url = getBackendURL(
			`/esr/geodata/${active_esr_id}/${question_id}/${identifier}/`,
		);
		request.delete(url).then(() => {
			dispatch({ type: "BUMP_SHAPE_VERSION" });
			dispatch(fetchESRResponses(active_esr_id));
			// dispatch(fetchESRSummary(active_esr_id));
		});
	};
}

export function submitESR(esr_id: string): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/esr/submit/");
		request
			.post<{
				auto_signoff_file_id: string;
			}>(url, { esr_id })
			.then(({ data: { auto_signoff_file_id } }) => {
				if (auto_signoff_file_id != null) {
					const previewUrl = getBackendURL(
						"/esr/attachment/?esr_id=" +
							esr_id +
							"&file_id=" +
							auto_signoff_file_id,
					);
					return preview(previewUrl);
				}
			})
			.finally(() => {
				dispatch(fetchESRSummary(esr_id));
			});
	};
}

export function updateCurrentUserGroups(): ESRThunkAction {
	return (dispatch) => {
		const user = getCurrentUser();
		if (!user) return;
		const url = getBackendURL("/clowder/list_user_groups");
		request
			.get<{
				groups: string[];
				group_names: string[];
				group_ids: string[];
			}>(url)
			.then(({ data }) => {
				setCurrentUser({ ...user, ...data });
				dispatch(listESRs(user.email));
				dispatch(listNotifications());
			});
	};
}

export function addUserToGroups(
	email: string,
	groupList: string,
	isAdmin: boolean,
): ESRThunkAction {
	return (dispatch) => {
		dispatch({
			type: "SET_QUESTION_LOADING_STATE",
			question_id: "__GLOBAL_LOADING__",
			loading: true,
		});
		const url = getBackendURL("/clowder/add_user_to_groups");
		return request
			.post(url, { email, group_names: groupList, is_admin: isAdmin })
			.then(({ data }) => {
				dispatch({
					type: ADD_USER_TO_GROUPS,
					email: email,
					groups: groupList,
				});
				// TODO: This may not be necessary as the UI gets updated with the added groups
				// in case the user's groups change
				// dispatch(updateCurrentUserGroups());
			})
			.finally(() => {
				dispatch({
					type: "SET_QUESTION_LOADING_STATE",
					question_id: "__GLOBAL_LOADING__",
					loading: false,
				});
			})
			.catch(console.log);
	};
}

export function removeUserFromGroup(
	email: string,
	group: string,
): ESRThunkAction {
	return (dispatch) => {
		dispatch({
			type: "SET_QUESTION_LOADING_STATE",
			question_id: "__GLOBAL_LOADING__",
			loading: true,
		});
		const url = getBackendURL("/clowder/remove_user_from_group");
		request
			.post(url, { email, group })
			.then(() => {
				dispatch({
					type: REMOVE_USER_FROM_GROUP,
					email: email,
					group: group,
				});
			})
			.finally(() => {
				dispatch({
					type: "SET_QUESTION_LOADING_STATE",
					question_id: "__GLOBAL_LOADING__",
					loading: false,
				});
			});
	};
}

export function listAllUsers(): ESRThunkAction {
	return (dispatch, getState) => {
		const searchParams = new URLSearchParams();
		const query = getState().user_sort_query;
		for (let [key, value] of Object.entries(query)) {
			if (value == null || (Array.isArray(value) && value.length === 0))
				continue;
			searchParams.set(key, value);
		}
		const url = getBackendURL(
			"/clowder/list_all_users?" + searchParams.toString(),
		);
		request.get(url).then(({ data }) => {
			return dispatch({
				type: LIST_ALL_USERS,
				users: data["data"],
				facets: data["facets"] ?? [],
			});
		});
	};
}

export function enableUser(email: string): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/clowder/enable_user");
		request
			.post(url, {
				email: email,
			})
			.then(() => {
				dispatch({
					type: UPDATE_USER_APPROVAL,
					email: email,
					enabled: true,
				});
				// get and update system notifications
				const url = getBackendURL(
					"/esr/sys_notifications/",
				);
				request.get(url).then(({ data: { sys_notifications} }) => {
					return dispatch<DataAction>({
						type: UPDATE_SYSTEM_NOTIFICATIONS,
						sys_notifications: sys_notifications,
					});
				});

			});
	};
}

export function disableUser(email: string): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/clowder/disable_user");
		request
			.post(url, {
				email: email,
			})
			.then(() => {
				return dispatch({
					type: UPDATE_USER_APPROVAL,
					email: email,
					enabled: false,
				});
			});
	};
}

export function enableUserAdmin(email: string): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/clowder/set_admin_user");
		request
			.post(url, {
				email: email,
			})
			.then(() => {
				return dispatch({
					type: UPDATE_USER_ADMIN,
					email: email,
					admin: true,
				});
			}).then(()=>{
					return dispatch({
					type: ADD_USER_TO_GROUPS,
					email: email,
					groups: JSON.stringify(['Admin']),
				})
			});
	};
	var url = `${process.env.REACT_APP_API_SERVER}/clowder/revoke_admin_user`;
}

export function disableUserAdmin(email: string): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/clowder/revoke_admin_user");
		request
			.post(url, {
				email: email,
			})
			.then(() => {
				return dispatch({
					type: UPDATE_USER_ADMIN,
					email: email,
					admin: false,
				});
			})
			.then(() => {
				return dispatch({
					type: REMOVE_USER_FROM_GROUP,
					email: email,
					group: 'Admin',
				});
			});
	};
}

export function saveSelectedUsersForSharing(
	esr_id: string,
	emails: string[],
): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/esr/update_esr_share_users/");
		request
			.post(url, {
				esr_id: esr_id,
				emails: emails,
			})
			.then((res) => {
				return dispatch({
					type: MERGE_USERS_SHARING,
					emails: res.data,
				});
			});
	};
}

export function setEmailNotificationFrequency(
	email: string,
	daily_report: boolean,
	weekly_report: boolean,
): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/esr/set_email_notification_frequency/");
		request
			.post(url, {
				email: email,
				daily_report: daily_report,
				weekly_report: weekly_report,
			})
			.then((res) => {
				return dispatch({
					type: UPDATE_EMAIL_NOTIFICATION_FREQUENCY,
					daily_report: daily_report,
					weekly_report: weekly_report,
				});
			});
	};
}

export function getEmailNotificationFrequency(email: string): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL(
			"/esr/get_email_notification_frequency/" + email + "/",
		);
		request.get(url).then(({ data }) => {
			return dispatch({
				type: UPDATE_EMAIL_NOTIFICATION_FREQUENCY,
				daily_report: data["daily_report"],
				weekly_report: data["weekly_report"],
			});
		});
	};
}

export function updateLastChangedESRQuestionID(question_id: string): ESRThunkAction {
	return (dispatch) => {
		dispatch({
			type: "UPDATE_ESR_LAST_QUESTION_ID",
			last_updated_question_id: question_id,
		});
	};
}

export function revokeSpecialEditPermissions(esr_id: string, user_id: string) {
	// Remove the Admin granted edit permissions (individual and bulk) held by the current user
	return (dispatch: ESRThunkDispatch) => {
		const url = getBackendURL(`/esr/revokespecialedit/${esr_id}/`);
		return request
			.post(url, {user_id: user_id})
			.then(() => {
				dispatch(fetchESRResponses(esr_id));
			}, console.error);
	};
}